import { ArrowUpRight, ArrowRight } from "lucide-react";
import LondonBackdrop from "@/components/LondonBackdrop";

const TICKER = [
  "PIPELINE ▲ £14.2M",
  "SIGNALS ▲ +128/sec",
  "MQL/SQL ▲ 3.1×",
  "HOT ACCTS ▲ 281",
  "CTR ▲ 5.7%",
  "CAC ▼ −17%",
  "CYCLE ▼ −28d",
  "ROI ▲ 100×",
  "ACCURACY ▲ 98%",
  "LATENCY ▼ 1.8s",
  "CONFIDENCE ▲ 94.2%",
  "CHURN ▼ −4.1%",
];

const PARTNERS = [
  "HubSpot", "Salesforce", "LinkedIn", "ZoomInfo", "Bombora",
  "6sense", "Marketo", "Segment", "Snowflake", "Outreach",
  "Salesloft", "Apollo", "Clearbit", "Gong",
];

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-32 md:pt-40 pb-16 overflow-hidden">
      {/* Animated London backdrop */}
      <LondonBackdrop />

      <div className="relative mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="max-w-5xl reveal">
          <div className="inline-flex items-center gap-2 rounded-full border border-teal/30 bg-teal/[0.08] backdrop-blur px-3 py-1 mb-8">
            <span className="h-1.5 w-1.5 rounded-full bg-teal pulse-dot" />
            <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-teal">
              RevGrow Services · Birmingham · London · Hyderabad
            </span>
          </div>

          <h1 className="font-display font-semibold text-4xl sm:text-5xl md:text-7xl lg:text-[92px] leading-[0.94] tracking-[-0.03em]">
            AI-Powered <span className="italic font-normal text-teal">Orchestration</span>
            <br />
            for High-Growth Teams.
          </h1>

          <p className="mt-8 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">
            RevGrow Services (UK) — the delivery arm of Revgrow Limited — turns
            intent signals into qualified pipeline for B2B teams that need signal,
            not noise. Strategy, data, media, and creative under one accountable roof.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a
              data-testid="hero-cta-primary"
              href="#contact"
              className="inline-flex items-center gap-1.5 rounded-full bg-teal text-[#050A0F] px-6 py-3.5 text-[14px] font-medium hover:opacity-90 transition glow-teal"
            >
              Book a strategy call <ArrowUpRight size={16} />
            </a>
            <a
              data-testid="hero-cta-secondary"
              href="#case-studies"
              className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.02] backdrop-blur px-6 py-3.5 text-[14px] hover:border-teal/50 hover:text-teal transition"
            >
              See case studies <ArrowRight size={16} />
            </a>
          </div>
        </div>

        {/* Integrations marquee */}
        <div className="mt-16 md:mt-24">
          <div className="flex items-center gap-6 mb-4">
            <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-muted-foreground">
              Integrates with
            </div>
            <div className="divider-line flex-1" />
          </div>
          <div className="overflow-hidden no-scrollbar">
            <div className="marquee-track flex gap-10 whitespace-nowrap">
              {[...PARTNERS, ...PARTNERS].map((p, i) => (
                <span key={i} className="text-lg md:text-xl font-display text-muted-foreground/70">
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* KPI ticker */}
        <div className="mt-6 border-y border-white/5 py-3 overflow-hidden no-scrollbar">
          <div className="marquee-track flex gap-6 whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.14em]">
            {[...TICKER, ...TICKER].map((t, i) => (
              <span key={i} className="text-teal/80">
                {t} <span className="text-white/20 mx-2">·</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
